import { siteContentEn } from "@/config/site.en";
import { siteContentEs } from "@/config/site.es";
import { createSiteConfig } from "@/lib/site-config";

export const siteConfig = createSiteConfig({
  shared: {
    business: {
      addressLines: [
        "Serving Puerto Rico",
        "Events by inquiry and appointment",
      ],
      email: "hello@joleanyeventplanner.com",
      hours: "Monday to Friday, 9:00 AM to 5:00 PM",
      phone: "+1 (787) 555-0100",
    },
    defaultOgImage: "/og/default.png",
    locales: ["en", "es"],
    organization: {
      legalName: "JPL Atelier",
      logo: "/J-Icon/J-Icon.svg",
      url: "https://joleanyeventplanner.com",
    },
    socialLinks: [],
    theme: {
      accent: "40 48% 56%",
      background: "40 22% 97%",
      buttonRadius: "0rem",
      fontBody: '"Manrope", ui-sans-serif, system-ui, sans-serif',
      fontDisplay: '"Noto Serif", ui-serif, Georgia, serif',
      foreground: "30 10% 10%",
      heroGlow: "38 18% 74%",
      primary: "0 0% 0%",
      radius: "0rem",
      sectionSpacing: "8rem",
      secondary: "30 34% 18%",
      shadowStrength: "30 12% 12%",
      surface: "0 0% 100%",
      surfaceMuted: "40 18% 95%",
      surfaceStrong: "30 30% 18%",
    },
    twitterHandle: "@joleanyevents",
  },
  locales: {
    en: siteContentEn,
    es: siteContentEs,
  },
});
